export const TypeColors = {
	normal: '#EF5350',
	fighting: '#ec407a',
	flying: '#ab47bc',
	poison: '#7e57c2',
	ground: '#5c6bc0',
	rock: '#42a5f5',
	bug: '#29b6f6',
	ghost: '#C4D0D6',
	steel: '#26c6da',
	fire: '#26a69a',
	water: '#66bb6a',
	grass: '#9ccc65',
	electric: '#d4e157',
	psychic: '#ffee58',
	ice: '#ffca28',
	dragon: '#ffa726',
	dark: '#ff7043',
	fairy: '#8d6e63',
	unknown: '#bdbdbd',
	shadow: '#78909c',
}